// src/modules/app-views/leads/pages/Document/actions/floatButton.js
// *******************************************************************************
// LEADS FLOAT BUTTON ACTIONS
// *******************************************************************************
// Float button actions for lead document operations.
// - Distribute: only when lead status is 'queue' (not yet distributed)
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SwapOutlined } from '@ant-design/icons';

// *******************************************************************************
// FLOAT BUTTON ACTIONS
// *******************************************************************************

/**
 * Build float button actions array for lead document
 * @param {Object} context - Context with data and handlers
 * @param {Object} context.data - Lead document data
 * @param {Object} context.handlers - Action handlers
 * @returns {Array} Array of float button action configurations
 */
const leadsDocumentFloatButton = (context = {}) => {
  const { data, handlers = {} } = context;

  // ─────────────────────────────────────────────────────────────────────────────
  // STATUS CHECKS
  // ─────────────────────────────────────────────────────────────────────────────
  const isNew = !data?._id || data?._id === 'add';
  const isQueue = data?.status === 'queue';

  // ─────────────────────────────────────────────────────────────────────────────
  // BUILD ACTIONS ARRAY
  // ─────────────────────────────────────────────────────────────────────────────
  const result = [
    // DISTRIBUTE LEAD - Only when status is 'queue'
    !isNew &&
      isQueue && {
        key: 'distribute',
        icon: <SwapOutlined />,
        tooltipText: 'distribute_leads',
        type: 'primary',
        onClick: handlers.onDistribute,
      },
  ].filter(Boolean);

  return result;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default leadsDocumentFloatButton;
